export default "__VITE_ASSET__WsaVh7TK__"